import { render, staticRenderFns } from "./ticket_statuses.vue?vue&type=template&id=6974852b&scoped=true&"
import script from "./ticket_statuses.vue?vue&type=script&lang=js&"
export * from "./ticket_statuses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6974852b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6974852b')) {
      api.createRecord('6974852b', component.options)
    } else {
      api.reload('6974852b', component.options)
    }
    module.hot.accept("./ticket_statuses.vue?vue&type=template&id=6974852b&scoped=true&", function () {
      api.rerender('6974852b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/ticket_statuses.vue"
export default component.exports